const ANALITICS_SECTIONS = {
	DASHBOARD_SECTION: '1',
	TASK_SECTION: '2',
	TASK_PAUSE_SECTION: '2.1',
	TASK_REJECT_SECTION: '2.2',
	GROUP_SECTION: '3',
	AGENT_SECTION: '4',
	CLIENT_SECTION: '5',
	BRANCH_SECTION: '6',
	COMPANY_SECTION: '7',
	MY_PARTNER_SECTION: '8',
	IAM_PARTNER_SECTION: '9',
};

export default ANALITICS_SECTIONS;
